export default __webpack_public_path__ + "4cf36b28f240aec9f55df2479b9fc089.gif";